import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import Container = Phaser.GameObjects.Container;
import {ClanControlAction, ClanmanInfo, ClanStat} from "@/store/clan/types";
import ClanUtils from "@/utils/clan-utils";
import {ListService} from "@/services/list-service";
import PlayerStore from "@/store/player";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class MemberActionPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, ci: ClanmanInfo, profileCallback: () => unknown, mailCallback: () => unknown, actionCallback: (action: ClanControlAction) => unknown) {
        super(scene, canvas, Tr('deystvija'));
        this.setDepth(ListService.DEPTH + 1);

        let blockFirst = TextUtils.addTextAdvanced(scene, ci.name, 0, -185,
            '#f3f3f3', 22, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let p = ci.participantInfo;
        let blockSecond = TextUtils.addTextAdvanced(scene, ClanUtils.getClanPositionName(ci.participantInfo) + Tr('comma.lev') + ci.level + (p ? (', ' + Tr('clan.exp') + ': ' + /*TextUtils.formatMoney(*/p!.clanStat.experience/*)*/) : '') + (p ? (', ' + Tr('clan.fights') + ': ' + p!.clanStat.battlesTotal) : ''), 0, blockFirst.y / CU.S + 40,
            '#afafaf', 12, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);
        this.add([blockFirst, blockSecond]);

        let player = PlayerStore.getPlayer();

        if (p && (ci.clanControlActions.length > 0 || player.id === ci.playerId)) {
            let s: ClanStat = p.clanStat;
            let blockThird = TextUtils.addTextAdvanced(scene, Tr('popolnenija.kr..kristalli') + s.redCrystal + ', ' + Tr('bl.cryst') + ': ' + s.blueCrystal + Tr('comma.zoloto') + s.gold + ', ' + Tr('izumrudi').toLowerCase() +': ' + s.gems, 0, blockSecond.y / CU.S + 45,
                '#afafaf', 12, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);
            this.add(blockThird);
        }

        if (player.id !== ci.playerId) {

            let pickActionText = TextUtils.addTextByFamily(scene, Tr('viberite.deystvie'), 0, -10,
                '#ffd465', 18, 'bold', 300, Fonts.MYRIADPRO_REGULAR);
            this.add(pickActionText.setVisible(ci.clanControlActions.length === 0));

            let actionButtons: Container[] = [];

            let scale = 0.85;

            ci.clanControlActions.forEach((ca: ClanControlAction) => {
                actionButtons.push(SpriteUtils.scale(this.addCustomButton(0, 0, ClanUtils.getActionName(ca), Keys.UI_ART_BROWN_BUTTON,
                    Keys.ATLAS_PROFILE, ClanUtils.getActionImg(ca), () => actionCallback(ca)), scale / CU.S));
            });

            let gridX = 140 - actionButtons.length * 70;
            Phaser.Actions.GridAlign(actionButtons, {
                width: actionButtons.length == 2 ? 2 : 3,
                cellWidth: 140 * CU.S,
                cellHeight: 160,
                x: gridX * CU.S - 70 * CU.S,
                y: 70 - 80,
            });

            this.addCustomButton(-90, 150, Tr('v.profil'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, profileCallback);
            this.addCustomButton(90, 150, Tr('napisat'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_MAIL, mailCallback);
        } else {
            this.addCustomButton(0, 150, Tr('horosho'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {});
        }
    }

}
